module.exports = __webpack_public_path__ + "img/doorbell.f2984104.png";